import { Inject, Injectable, Optional, Pipe, PipeTransform } from '@angular/core';
import { ClientPath } from '@shared/models/client-path.enum';
import { CLIENT_PATH } from '@shared/shared/injection-tokens';

@Pipe({
  name: 'customCurrencyPipe',
  standalone: true,
})
@Injectable()
export class CustomCurrencyPipe implements PipeTransform {
  constructor(@Optional() @Inject(CLIENT_PATH) public clientPath: ClientPath) {}

  public transform(value: string): string {
    if (!value) {
      return value;
    }

    if (value.includes('GBP')) {
      return '£' + value.replace('GBP', '').trim();
    }

    if (value.includes('£GB')) {
      return '£' + value.replace('£GB', '').trim();
    }

    if (value.includes('USD')) {
      return 'US$' + value.replace('USD', '').trim();
    }

    if (value.includes('US$')) {
      return 'US$' + value.replace('US$', '').trim();
    }

    if (value.includes('NOK')) {
      return 'kr ' + value.replace('NOK', '').trim();
    }

    if (value.includes('CHF')) {
      return 'CHF ' + value.replace('CHF', '').replace(',', "'").trim();
    }

    if (
      value.includes('MXN$') ||
      value.includes('MXN') ||
      value.includes('MX$') ||
      value.includes('MX') ||
      value.includes('$MX')
    ) {
      let clean = this.checkMXN(value);
      clean = clean.trim();

      // Detect if we have European decimal formatting (comma as decimal separator)
      // by checking the 3rd character from the end (after the 2-digit decimal part)
      const parts = clean.split('');
      if (parts.length >= 3) {
        parts.pop(); // Remove last decimal digit
        parts.pop(); // Remove first decimal digit
        const hasCommaAsDecimalSeparator = parts.pop() === ',';

        let formatted: string;
        if (hasCommaAsDecimalSeparator) {
          // Convert European format (5.572,73) to US format (5,572.73)
          // Step 1: Replace all dots with temp marker |
          // Step 2: Replace comma (decimal) with dot
          // Step 3: Replace all temp markers | with commas (thousands separators)
          formatted = clean.replace(/\./g, '|').replace(',', '.').replace(/\|/g, ',');
        } else {
          formatted = clean;
        }

        return `MXN$ ${formatted}`;
      } else {
        return `MXN$ ${clean}`;
      }
    }

    return value;
  }

  private checkMXN(value: string): string {
    if (value.includes('MXN$')) {
      return value.replace('MXN$', '');
    }

    if (value.includes('MXN')) {
      return value.replace('MXN', '');
    }

    if (value.includes('MX$')) {
      return value.replace('MX$', '');
    }

    if (value.includes('$MX')) {
      return value.replace('$MX', '');
    }

    if (value.includes('MX')) {
      return value.replace('MX', '');
    }

    return value;
  }
}
